import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';
import { FileCopy } from '@mui/icons-material';

const HeaderLinks = ({ onClickClose, onDuplicate, canWrite }) => {
  const { t } = useTranslation();

  return (
    <>
      <IconButton fontSize='medium' color='transparent' tooltip={t('Duplicate')} disabled={!canWrite} onClick={onDuplicate}>
        <FileCopy color='primary' />
      </IconButton>
      <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.FinancialProduct.BackToList')} onClick={onClickClose}>
        <ArrowBack />
      </IconButton>
    </>
  );
};

HeaderLinks.propTypes = {
  onClickClose: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  canWrite: PropTypes.bool.isRequired
};

export default HeaderLinks;
